var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTickIconRed(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1280.000000pt",
    height: "1253.000000pt",
    viewBox: "0 0 1280.000000 1253.000000",
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.000000,1253.000000) scale(0.100000,-0.100000)",
    fill: "#F00",
    stroke: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12010 12523 c-684 -73 -1764 -825 -3384 -2358 -1193 -1128 -2995 -3055 -4284 -4582 l-154 -181 -151 79 c-805 422 -1574 773 -2097 957 -512 180 -860 251 -1165 239 -170 -7 -264 -29 -395 -93 -77 -39 -109 -62 -175 -128 -127 -127 -189 -270 -202 -462 -5 -76 -2 -102 15 -160 29 -91 56 -123 312 -361 415 -386 896 -885 1231 -1278 791 -926 1573 -2094 2509 -3745 166 -293 199 -341 257 -381 142 -98 318 -88 449 24 53 46 85 108 183 355 461 1155 1080 2472 1658 3532 1043 1910 2180 3546 3508 5045 505 570 961 1038 1785 1831 658 632 790 784 861 991 90 262 -41 514 -323 623 -127 49 -289 69 -438 53z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTickIconRed);
export default __webpack_public_path__ + "static/media/tick-icon-red.615878b4b644de036ae851de344810ed.svg";
export { ForwardRef as ReactComponent };